import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaEquipamento.vue?vue&type=template&id=f8d3c8a8&scoped=true"
import script from "./ModalSolicitacaoCirurgiaEquipamento.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaEquipamento.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoCirurgiaEquipamento.vue?vue&type=style&index=0&id=f8d3c8a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d3c8a8",
  null
  
)

export default component.exports